import type { GatsbyLinkProps } from 'gatsby';
import type { AnchorHTMLAttributes, ForwardRefExoticComponent, RefAttributes } from 'react';
import { Link as I18nextLink } from 'gatsby-plugin-react-i18next';

export type LocalizedLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> &
  Pick<
    GatsbyLinkProps<unknown>,
    'to' | 'activeClassName' | 'activeStyle' | 'partiallyActive' | 'replace' | 'state' | 'getProps'
  > & {
    language?: string;
  };

// Keep the plugin's runtime component and ref forwarding. Its generated declaration
// makes newer React DOM attributes required even though the component does not need them.
const LocalizedLink = I18nextLink as ForwardRefExoticComponent<
  LocalizedLinkProps & RefAttributes<HTMLAnchorElement>
>;

export default LocalizedLink;
